import React from 'react';
import { Container, Row, Spinner } from 'reactstrap';

/**
 * Renders the preloader
 */
const Loader = ({height, text = 'Loading...'}) => {
    const loaderHeight = height || '85vh';
    return (
        <React.Fragment>
            <Container fluid={true}>
                <Row className="align-items-center justify-content-md-center" style={{height: loaderHeight}}>
                    <div>
                        <div style={{textAlign: 'center'}}>
                            <Spinner animation="border" color="primary" />
                        </div>
                        
                        <div style={{paddingLeft: '5px'}}>{text}</div>                    
                    </div>                    
                </Row>
            </Container>
        </React.Fragment>
    );
};
export default Loader;
